import React from 'react';
import {Button} from '@tickchak/react-share/app';
import * as css from '../../WhatsAppTemplateEditor.css';
import WhatsAppEditorWarningBadges from '../whatsAppEditorWarningBadges/WhatsAppEditorWarningBadges';

interface WhatsAppTemplateEditorToolbarProps {
    totalCharacters: number;
    filledParagraphsCount: number;
    totalParagraphsCount: number;
    hasDisabledVariables: boolean;
    onClearAll: () => void;
    clearAllLabel: string;
    toolbarExtra: React.ReactNode;
}

function WhatsAppTemplateEditorToolbar({
    totalCharacters,
    filledParagraphsCount,
    totalParagraphsCount,
    hasDisabledVariables,
    onClearAll,
    clearAllLabel,
    toolbarExtra,
}: WhatsAppTemplateEditorToolbarProps) {
    return (
        <css.topRow>
            <WhatsAppEditorWarningBadges
                totalCharacters={totalCharacters}
                filledParagraphsCount={filledParagraphsCount}
                totalParagraphsCount={totalParagraphsCount}
                hasDisabledVariables={hasDisabledVariables}
            />
            <css.toolbar>
                <Button
                    variant="neutral"
                    size="chip"
                    onClick={onClearAll}
                    title={clearAllLabel}
                    data-cy="whatsapp-editor-clear-all-btn"
                >
                    {clearAllLabel}
                </Button>
                {toolbarExtra}
            </css.toolbar>
        </css.topRow>
    );
}

export default WhatsAppTemplateEditorToolbar;
